import React from "react";
import { Box, Card, IconButton, Typography, Grid } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ImagePreviewGrid } from "@modules/application-section/components/ImagePreviewGrid";
import { setActiveStep } from "@modules/stepper/redux/stepperSlice";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "@store/store";
import { useDispatch } from "react-redux";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

export const MediaUpload: React.FC<{
  isExpanded: boolean;
  toggleExpand: () => void;
  visible?: boolean;
}> = ({ isExpanded, toggleExpand, visible = true }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9" }}>
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 2,
            borderBottom: "1px solid #E7E8E9",
            py: "5px",
          }}
        >
          <Typography
            className="preview-dropdown-header"
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
          >
            Uploaded Plot Pictures
            {/* <IconButton
                            className="ml-4"
                            onClick={() => {
                                dispatch(setActiveStep(2));
                                navigate("/stepper#upload-plot-pictures");
                            }}
                        >
                            <ModeEditOutlineOutlinedIcon />
                        </IconButton>

                        Uploaded Plot Pictures */}
            {visible && (
              <IconButton
                className="ml-4"
                onClick={() => {
                  dispatch(setActiveStep(2));
                  navigate("/stepper#upload-plot-pictures");
                }}
              >
                <ModeEditOutlineOutlinedIcon />
              </IconButton>
            )}
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>
        {isExpanded && (
          <Box sx={{ pt: 2, px: 2 }}>
            <ImagePreviewGrid visibleIcons={false} />
          </Box>
        )}
      </Card>
    </Box>
  );
};
